import { useInfiniteQuery } from "@tanstack/react-query";
import {
	limit,
	makeOffsetInfiniteQueryOptions,
	useResetInfiniteData,
} from "web_myplann/Api/infiniteQueryUtils";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { getTaskV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useTaskListInfiniteQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	filterSortdesc?: boolean,
	pageSize: number = limit,
) => {
	const queryKey = TaskKeys.infiniteList(
		filterDatefrom,
		filterDateto,
		filterOnlyunsolved,
		filterOnlysolved,
		filterSortdesc,
		pageSize,
	);

	useResetInfiniteData(queryKey);

	return useInfiniteQuery({
		queryKey,
		queryFn: (ctx) =>
			processResponseQuery(() =>
				getTaskV2(
					filterDatefrom,
					filterDateto,
					filterOnlyunsolved,
					filterOnlysolved,
					pageSize,
					ctx.pageParam,
					filterSortdesc,
				),
			)(ctx),
		...makeOffsetInfiniteQueryOptions({ pageSize }),
	});
};
